export default __webpack_public_path__ + "static/media/2753.61282c10.png";